import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Dialog, Form, InputNumber } from 'tdesign-react';
import styled from 'styled-components';
import { updateGeoPolice } from '@/services/topicService';
import Text from '@/components/Text';
import Tip from '@/components/Tip';
import { isEmptyPolicy } from '..';

const { FormItem } = Form;

function PolicyForm({ visible, handleClose, topic, geoPolice }) {
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const [submitting, setSubmitting] = useState(false);

  const clusterName = searchParams.get('name');

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      setSubmitting(true);
      try {
        const parmas = {
          ...geoPolice,
          ...fields,
          clusterName,
          topic,
        };
        await updateGeoPolice(parmas);
        handleClose(true);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  useEffect(() => {
    if (visible) {
      if (isEmptyPolicy(geoPolice)) {
        form.setFields([{ name: 'topic', value: topic }]);
      } else {
        form.setFieldsValue(geoPolice);
      }
    } else {
      form.reset();
    }
  }, [visible, form, geoPolice, topic]);

  return (
    <Root
      onConfirm={() => form.submit()}
      confirmBtn={{ loading: submitting, content: '确定' }}
      visible={visible}
      header='限流配置'
      width={550}
      onClose={() => handleClose()}
    >
      <Form form={form} style={{ width: '90%' }} labelWidth={120} onSubmit={handleSubmit}>
        <FormItem name='topic' label='Topic'>
          <Text />
        </FormItem>
        <FormItem
          name='dispatchThrottlingRateMsg'
          rules={[{ required: true, message: '速率必填' }]}
          label={<Tip content='目前均实际限制到分区粒度'>速率</Tip>}
        >
          <InputNumber theme='normal' suffix='条/s' decimalPlaces={0} />
        </FormItem>
        <FormItem
          name='dispatchThrottlingRateBytes'
          rules={[{ required: true, message: '吞吐必填' }]}
          label={<Tip content='目前均实际限制到分区粒度'>吞吐</Tip>}
        >
          <InputNumber theme='normal' suffix='Byte/s' decimalPlaces={0} />
        </FormItem>
      </Form>
    </Root>
  );
}

export default connect((state) => ({
  geoPolice: state.topic.geoPolice,
}))(PolicyForm);

const Root = styled(Dialog)`
  .t-input-number {
    width: auto;
    flex: 1;
  }
  .t-input__suffix {
    color: var(--td-font-gray-2);
  }
`;
